/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../payments/set_metadata';
import '../../common/currency';
import '../common/common';
import '../../common/location';
import '../../common/emv';
import './mastercard_mip';
import '../api/capture';
import './batch';
import '../api/itemization';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "model": {
            "nested": {
              "CaptureIntentIccData": {
                "fields": {
                  "transactionCertificate": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "DelayCaptureIntent": {
                "fields": {
                  "delayCaptureReason": {
                    "type": ".squareup.payments.api.DelayCaptureReason",
                    "id": 1,
                    "rule": "optional"
                  },
                  "createdAtMs": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CaptureIntent": {
                "fields": {
                  "createdAtMs": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "totalAmount": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "tipAmount": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "taxAmount": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "processingDateMs": {
                    "type": "uint64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "businessDateMs": {
                    "type": "uint64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "iccData": {
                    "type": ".squareup.esperanto.model.CaptureIntentIccData",
                    "id": 7,
                    "rule": "optional"
                  },
                  "customerPresence": {
                    "type": ".squareup.esperanto.common.CustomerPresence",
                    "id": 8,
                    "rule": "optional"
                  },
                  "geoLocation": {
                    "type": ".squareup.common.location.GeoLocation",
                    "id": 9,
                    "rule": "optional"
                  },
                  "timeZone": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "captureGatewayTransactionId": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "emvTags": {
                    "type": ".squareup.common.EmvTags",
                    "id": 12,
                    "rule": "optional"
                  },
                  "clientRequestedAtMs": {
                    "type": "int64",
                    "id": 14,
                    "rule": "optional"
                  }
                }
              },
              "CaptureResult": {
                "fields": {
                  "status": {
                    "type": ".squareup.esperanto.common.OperationStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "acknowledgedByPbsAtMs": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "messageFromPbs": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CaptureGatewayProperties": {
                "fields": {
                  "mastercardMip": {
                    "type": ".squareup.esperanto.model.MipCaptureGatewayProperties",
                    "id": 1
                  }
                },
                "nested": {
                  "properties": {
                    "oneof": ["mastercardMip"]
                  }
                }
              },
              "Capture": {
                "fields": {
                  "delayCaptureIntent": {
                    "type": ".squareup.esperanto.model.DelayCaptureIntent",
                    "id": 5,
                    "rule": "optional"
                  },
                  "captureIntent": {
                    "type": ".squareup.esperanto.model.CaptureIntent",
                    "id": 1,
                    "rule": "optional"
                  },
                  "captureResult": {
                    "type": ".squareup.esperanto.model.CaptureResult",
                    "id": 2,
                    "rule": "optional"
                  },
                  "captureUuid": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "captureRequestId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "captureType": {
                    "type": ".squareup.esperanto.api.CaptureType",
                    "id": 6,
                    "rule": "optional"
                  },
                  "batchDetails": {
                    "type": ".squareup.esperanto.model.BatchDetails",
                    "id": 7,
                    "rule": "optional"
                  },
                  "itemizationData": {
                    "type": ".squareup.esperanto.api.ItemizationData",
                    "id": 8,
                    "rule": "optional"
                  },
                  "gatewayProperties": {
                    "type": ".squareup.esperanto.model.CaptureGatewayProperties",
                    "id": 9,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.CaptureIntentIccData && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.DelayCaptureIntent && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.CaptureIntent && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.CaptureResult && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.CaptureGatewayProperties && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.Capture) {
  $root.addJSON(jsonData);
}

/**
 * ICC-related data from the capture.
 *
 * All of these fields are hex-encoded.
 *
 * SOURCE CaptureIntentIccData @ squareup/esperanto/model/capture.proto at 24:1
 */
export const CaptureIntentIccData = $root.lookupType('squareup.esperanto.model.CaptureIntentIccData');
fixType(CaptureIntentIccData);
Builder.createAndAttachToType(CaptureIntentIccData);
/**
 * Delay capture intent. Wrapper for a reason the capture is delayed and a timestamp. This
 * is an optional initial state for a capture and thus can only be set when there is no capture
 * intent or result. Will persist after capture intent and result are set.
 *
 * SOURCE DelayCaptureIntent @ squareup/esperanto/model/capture.proto at 33:1
 */
export const DelayCaptureIntent = $root.lookupType('squareup.esperanto.model.DelayCaptureIntent');
fixType(DelayCaptureIntent);
Builder.createAndAttachToType(DelayCaptureIntent);
/**
 * Capture intent.
 *
 * SOURCE CaptureIntent @ squareup/esperanto/model/capture.proto at 43:1
 */
export const CaptureIntent = $root.lookupType('squareup.esperanto.model.CaptureIntent');
fixType(CaptureIntent);
Builder.createAndAttachToType(CaptureIntent);
/**
 * Capture result.
 *
 * SOURCE CaptureResult @ squareup/esperanto/model/capture.proto at 84:1
 */
export const CaptureResult = $root.lookupType('squareup.esperanto.model.CaptureResult');
fixType(CaptureResult);
Builder.createAndAttachToType(CaptureResult);
/**
 * Attributes of a Capture that are gateway specific and are visible beyond payment processing
 * systems.
 *
 * SOURCE CaptureGatewayProperties @ squareup/esperanto/model/capture.proto at 99:1
 */
export const CaptureGatewayProperties = $root.lookupType('squareup.esperanto.model.CaptureGatewayProperties');
fixType(CaptureGatewayProperties);
Builder.createAndAttachToType(CaptureGatewayProperties);
/**
 * Capture transaction.
 *
 * SOURCE Capture @ squareup/esperanto/model/capture.proto at 108:1
 */
export const Capture = $root.lookupType('squareup.esperanto.model.Capture');
fixType(Capture);
Builder.createAndAttachToType(Capture);